import { Component, input, output, signal, viewChild, inject, AfterViewInit, ChangeDetectionStrategy, TemplateRef } from '@angular/core';
import { ModalService } from "@components/modal/modal.service";
import { ModalBodyComponent } from "@components/modal/modal-body/modal-body.component";
import { ModalHeaderComponent } from "@components/modal/modal-header/modal-header.component";
import { ModalFooterComponent } from "@components/modal/modal-footer/modal-footer.component";
import { ButtonComponent } from "@components/button/button.component";

@Component({
  selector: 'app-confirmation',
  imports: [ModalBodyComponent, ModalHeaderComponent, ModalFooterComponent, ButtonComponent],
  templateUrl: './confirmation.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './confirmation.component.scss'
})
export class ConfirmationComponent implements AfterViewInit {
  private readonly ModalService = inject(ModalService);

  public Title = input.required<string>();
  public Body = input.required<string>();
  public ConfirmButtonText = input.required<string>();
  public RejectButtonText = input.required<string>();
  public InternalModalTemplate = viewChild.required("confirmationModalTemplate", { read: TemplateRef });
  public OnCancelButtonClicked = output<void>();
  public OnConfirmButtonClicked = output<void>();
  public OnClosed = output<void>();
  /**
   * When true, will prevent the modal from being closed or interacted with.
   */
  public IsProcessing = signal<boolean>(false);

  public ngAfterViewInit(): void {
    const modalRef = this.ModalService.ShowModal(this.InternalModalTemplate(), undefined, {
      PreventClosing: this.IsProcessing
    });
    modalRef.instance.OnClosed.subscribe(() => {
      this.OnClosed.emit();
    });
  }

  public Close(): void {
    this.ModalService.CloseCurrentModal();
  }
}